import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent
} from "@wms/components";
import {filter, flatten, forEach, includes, map, startsWith, trim, uniq} from "lodash-es";
import {each, findIndex} from "lodash-es";
import { TabsModule } from "ngx-bootstrap/tabs";
import { WmComponentsModule ,FilterPipe} from "@wm/components-base";
import {DialogService, FileService} from "@wms/services";
import {loadStyleSheet} from "@wms/core";


@Component({
  selector: 'wms-icon-selector',
  standalone: true,
  imports: [CommonModule, WmsDialogComponent, FormsModule, TabsModule, WmsDialogHeaderComponent,
    WmsDialogBodyComponent, WmsDialogFooterComponent, WmComponentsModule,FilterPipe],
  templateUrl: './wms-icon-selector.component.html',
  styleUrls: ['./wms-icon-selector.component.less']
})


export class WmsIconSelectorComponent extends BaseComponent implements OnInit {
  @Input() Icon: string;
  @Output() handleClose = new EventEmitter<any>();
  @Output() handleChanges = new EventEmitter<{ boundVariable: any, boundProperty: any, boundVariableType: any }>();
  activeTabIndex: number= 0;
  selectedIconExpr: string;
  selectedIcon: any = {};
  iconSearchText: string = '';
  fontAwesomeOptions:any;
  tabs:any=[];
  iconFamilies:any;
  fileService:FileService;
  dialogeService:DialogService;
  activeImportedIcons:boolean
  public isPrism: boolean = false;

  constructor() {
    super();
    this.fileService = inject(FileService);
    this.dialogeService = inject(DialogService);
    this.eventManager.updateOnIconImport().subscribe(()=>{
      this.getIconSFamily()
      this.activeImportedIcons= true;
    })

  }

  ngOnInit(): void {
    this.isPrism = this.projectService.isPrism();
    this.getIconSFamily();
  }

  getIconSFamily(){
    this.getCustomIcon();
    import('../../../assets/resources/files/iconsList').then(iconList => {

      this.iconFamilies = [
        {
          name: 'streamline-light',
          prefix: 'wm-sl-l sl-',
          categories: this.getIconCategories(iconList.streamlineLightCategories),
          selectedCategory: {
            'name': 'all',
            'icons': []
          },
          render: false
        }, {
          name: 'streamline-regular',
          prefix: 'wm-sl-r sl-',
          categories: this.getIconCategories(iconList.streamlineRegularCategories),
          selectedCategory: {
            'name': 'all',
            'icons': []
          },
          render: false
        }, {
          name: 'wavicon',
          prefix: 'wi wi-',
          categories:this.getIconCategories(iconList.waviconCategories),
          selectedCategory: {
            'name': 'all',
            'icons': []
          },
          render: false
        },
        {
          name: 'font-awesome',
          prefix: 'fa fa-',
          categories: this.getIconCategories(iconList.fontAwesomeIconCategories),
          selectedCategory: {
            'name': 'web-application',
            'icons': []
          },
          render: false
        },
        ...(this.isPrism
          ? [{
              name: 'materialicon',
              prefix: 'mi mi-',
              categories: this.getIconCategories(iconList.materialIconCategories),
              selectedCategory: {
                name: 'all',
                icons: []
              },
              render: false
            }]
          : [])
      ];
      this.fontAwesomeOptions=iconList.fontAwesomeOptions;
    }).then(() => {
      forEach(this.iconFamilies, (family) => {
        this.selectIconCategory(family, '')
      })
      this.extractIconProperties(this.Icon);
    }).then(()=>{

      let familyToSelect=Math.max(findIndex(this.iconFamilies,(f:any)=>{
        return startsWith(this.selectedIcon.name,f.prefix);
      }),0);
      this.renderIconFamily(familyToSelect);
    })
  }

   getCustomIcon () {
     let url = 'resources/icons/designer.js'
     this.fileService.read(url).then((result) => {
       result = result.replace('export default ', '');
       result = JSON.parse(result);
       for (let i in result) {
         let iconFamily = {
           name: i,
           prefix: i + ' ',
           categories: [{
             'name': 'all',
             'icons': result[i]
           }],
           selectedCategory: {
             'name': 'all',
             'icons': result[i]
           },
           render: false
         }
         let appCssPath = '/studio/services/projects/' + this.projectService.getProjectId()
           + '/resources/info/web/resources/icons/';
         loadStyleSheet(appCssPath + i + "/style.css", {name: "font", value: i});
         if (findIndex(this.iconFamilies, iconFamily) < 0) {
           this.iconFamilies.push(iconFamily);
           this.fileService.storeIconFamiliesList = this.iconFamilies;
           if (this.activeImportedIcons) {
             let index = this.iconFamilies.findIndex((icon: any) => icon.name === iconFamily.name);
             this.renderIconFamily(index)
           }

         }
       }

     });

   }

  getIconCategories(rawIconCategories: any) {
    const iconCategories: any[] = [].concat(rawIconCategories);
    iconCategories.push({
      'name': 'all',
      'icons': uniq(flatten(map(rawIconCategories, (iconCategory) => {
        return iconCategory.icons;
      })))
    });
    return iconCategories;
  }

  setFormattedIconExpr() {
    this.selectedIconExpr = this.selectedIcon.name || '';
    each(this.selectedIcon, (value, key) => {
      if (value && key !== 'name') {
        this.selectedIconExpr += ' ' + value;
      }
    });
  }

  extractIconProperties(icon: string) {
    let iconExpr = icon || '';
    each(this.fontAwesomeOptions, (value, key) => {
      iconExpr.split(' ').forEach((iconProperty: any) => {
        if (iconProperty) {
          let regEx = new RegExp('\\b' + iconProperty + '\\b');
          if (includes(value, iconProperty)) {
            this.selectedIcon[key] = iconProperty;
            iconExpr = iconExpr.replace(regEx, '');
          }
        }
      })
    });
    this.selectedIcon.name = trim(iconExpr,' ');
    this.setFormattedIconExpr();
  }

  renderIconFamily(iconFamilyIndex: number) {
    this.activeTabIndex = iconFamilyIndex;
    this.iconFamilies[iconFamilyIndex].render = true;
  }

  selectIconCategory(selectIconFamily: any, iconCategoryName?: string) {
    let selectedCategory = selectIconFamily.selectedCategory;
    selectedCategory.name = iconCategoryName = (iconCategoryName || selectedCategory.name);
    selectedCategory.icons = filter(selectIconFamily.categories, (category) => {
      return category.name === iconCategoryName;
    })[0].icons;

  };

  selectIcon(iconClass: any) {
    this.selectedIcon.name = iconClass;
    this.setFormattedIconExpr();
  }

  saveIcon() {
    this.setFormattedIconExpr();
    this.handleChanges.emit({
      boundVariable: this.selectedIconExpr,
      boundProperty: 'iconclass',
      boundVariableType: 'expression'
    });
  }

  onIconPropertyChange(key: string) {
    if (key === 'fixedWidth' && this.selectedIcon.fixedWidth === false) {
      this.selectedIcon.fixedWidth = false;

    } else if (key === 'border' && this.selectedIcon.border === false) {
      this.selectedIcon.border = false;
    }
    if (key === 'fixedWidth' && this.selectedIcon.fixedWidth === true) {
      this.selectedIcon.fixedWidth = 'fa-fw'
      this.selectedIcon.border = false;
    }
    if (key === 'border' && this.selectedIcon.border === true) {
      this.selectedIcon.border = 'fa-border'
      this.selectedIcon.fixedWidth = false;
    }
    this.setFormattedIconExpr()

  };
  openResourceDialog(){
    this.dialogeService.open('importIconsDialoge')
  }



  onClose(): void {
    this.handleClose.emit();
  }

}
